import { getLoadMstv } from "./mstv-player-loader";
import device from 'current-device';

export function stickyVideo(dataEdtn, $window) {
    var $videoBoxWrapper = $('.videowrapper'); //mstv-video-wrapper
    var $videoWrapper = $('.videowrapper .video-player'); //video-player
    var isMstv = $videoBoxWrapper.hasClass('mstv-video-wrapper') ? true : false;
    // var infiniteScrollEdtn = arrayInfiniteScroll;

    // var enableVideoScroll;

    // if ($videoBoxWrapper.length && ($videoBoxWrapper.hasClass('youtube-video-wrapper') || $videoBoxWrapper.hasClass('mstv-video-wrapper')) && (device.type == 'desktop' && window.innerWidth > 1919)) {
    //   enableVideoScroll = true;
    // }

    // if (enableVideoScroll) {
    //   var videoHeight = $videoWrapper.outerHeight();
    //   document.querySelectorAll('.videoBoxArticle .videoBoxArticle-wrapper').forEach(function(videoBoxWrapper) {
		// 		const videoWrapper = videoBoxWrapper.querySelector('.video-player');
    //     videoWrapper.addEventListener('click', function(e) {
    //       if(e.target.classList.contains('video-player-close')) {
    //         window.notStickThisVideo = true;
    //         let player = videoWrapper.querySelector('iframe');
    //         let command4Youtube = {
    //           "event": "command",
    //           "func": "pauseVideo"
    //         }
    //         let command4Mstv = {
    //           player:{
    //             action: 'pause',
    //             value: ''
    //           }
    //         }
    //         if(player) {
    //           if(videoBoxWrapper.classList.contains('youtube-video-wrapper')){
    //             player.contentWindow.postMessage(JSON.stringify(command4Youtube), "*");
    //           } else if (videoBoxWrapper.classList.contains('mstv-video-wrapper')) {
    //             player.contentWindow.postMessage(command4Mstv, "*");
    //           }
    //         }
    //         videoWrapper.classList.remove('stick');
    //         document.body.classList.remove('custom-zindex');
    //       }
    //     })
    //   });


    //   $window.on('scroll', function() {
    //     $videoBoxWrapper.each(function(index, wrapper) {
    //       const $wrapper = $(wrapper);
    //       const $videoWrapper = $wrapper.find('.video-player');
    //       let player = $wrapper.find('iframe').get(0);
    //       let command4Youtube = {
    //         "event": "command",
    //         "func": "pauseVideo"
    //       }
    //       let command4Mstv = {
    //         player:{
    //           action: 'pause',
    //           value: ''
    //         }
    //       }

    //       if (window.notStickThisVideo) {
    //         if ($videoWrapper.hasClass('stick')) {
    //           $videoWrapper.removeClass('stick');
    //         }
    //         if ($('body').hasClass('custom-zindex')) {
    //           $('body').removeClass('custom-zindex');
    //         }
    //         return;
    //       }
    //       var closestRoot = $videoWrapper.closest('.article-container')[0];
    //       if (closestRoot) {
    //         var closestRootRect = closestRoot.getBoundingClientRect();
    //         var distanceToBottom = window.innerHeight - closestRootRect.bottom;
    //       }
          
    //       var windowScrollTop = $window.scrollTop();
    //       var videoBottom = videoHeight + $wrapper.offset().top;
    //       // var stopScrollPoint = Math.floor($(closestRoot).height() - $(document).scrollTop() - $(window).height());
  
    //       if ( windowScrollTop > videoBottom) {
    //         $videoWrapper.addClass('stick');
    //         $('body').addClass('custom-zindex');
    //       } else {
    //         // $videoBoxWrapper.height('auto');
    //         $videoWrapper.removeClass('stick');
    //         $('body').removeClass('custom-zindex');
    //       }
  
    //       // stop scroll before some point in the bottom
    //       if (distanceToBottom >= 0 && infiniteScrollEdtn.includes(dataEdtn)) {
    //         $videoWrapper.addClass('stop_stick');
    //         if (player != undefined) {
    //           if ($wrapper.hasClass('youtube-video-wrapper')) {
    //             player.contentWindow.postMessage(JSON.stringify(command4Youtube), "*");
    //           } else if ($wrapper.hasClass('mstv-video-wrapper')) {
    //             player.contentWindow.postMessage(command4Mstv, "*");
    //           }
    //         }
    //       } else {
    //         $videoWrapper.removeClass('stop_stick');
    //       }
    //     });
    //     });
    // }

    if ($videoWrapper != null) {
      $videoWrapper.each(function(index, wrapper) {
        const $wrapperCurrent = $(wrapper);
        const $playBtn = $wrapperCurrent.find('.play-button')[0];
        const clearSvg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title>clear</title>
        <path d="M25.312 9.216l-7.424 7.456 7.424 7.424-1.888 1.888-7.424-7.456-7.424 7.456-1.888-1.888 7.424-7.424-7.424-7.456 1.888-1.856 7.424 7.424 7.424-7.424z"></path>
        </svg>`;
        if($playBtn == undefined) return;
        getLoadMstv().then((api) => {
          api.loadMstv($wrapperCurrent, clearSvg, dataEdtn, isMstv);
        });
      });
    }
}

// export function stickyVideo() {
//     var $videoBoxWrapper = document.querySelector('.videoBoxArticle .videoBoxArticle-wrapper'); //mstv-video-wrapper
//     var $videoWrapper = document.querySelector('.videoBoxArticle .video-player'); //video-player
//     var isMstv = $videoBoxWrapper.classList.contains('mstv-video-wrapper') ? true : false;
//     var $dataEdtn = document.body.dataset.edtn;
//     var infiniteScrollEdtn = ['it'];

//     var enableVideoScroll;

//     if ($videoBoxWrapper !== null && ($videoBoxWrapper.classList.contains('youtube-video-wrapper') || $videoBoxWrapper.classList.contains('mstv-video-wrapper')) && (device.type == 'desktop' || device.type == 'mobile')) {
//       enableVideoScroll = true;
//     }

//     if (enableVideoScroll) {
//         var videoHeight = $videoWrapper.getBoundingClientRect().height;
//         window.addEventListener('scroll', event => {
//             if (window.notStickThisVideo) {
//                 if ($videoWrapper.classList.contains('stick')) {
//                   $videoWrapper.classList.remove('stick');
//                 }
      
//                 if (document.body.classList.contains('custom-zindex')) {
//                   document.body.classList.remove('custom-zindex')
//                 }
//                 return;
//             }
      
//             var closeVideoScrollButton = document.querySelector('.video-player.stick .video-player-close');
//             closeVideoScrollButton.addEventListener('click', event => {
//                 window.notStickThisVideo = true;

//                 let player = $videoBoxWrapper.querySelector('iframe');
//                 let command4Youtube = {
//                     "event": "command",
//                     "func": "pauseVideo"
//                 }
//                 let command4Mstv = {
//                     player:{
//                         action: 'pause',
//                         value: ''
//                     }
//                 }
      
//                 if (player != undefined) {
//                     if ($videoBoxWrapper.classList.contains('youtube-video-wrapper')) {
//                         player.contentWindow.postMessage(JSON.stringify(command4Youtube), "*");
//                     } else if ($videoBoxWrapper.classList.contains('mstv-video-wrapper')) {
//                         player.contentWindow.postMessage(command4Mstv, "*");
//                     }
//                 }
      
//                 if ($videoWrapper.classList.contains('stick')) {
//                     $videoWrapper.classList.remove('stick');
//                 }
        
//                 if (document.body.classList.contains('custom-zindex')) {
//                     document.body.classList.remove('custom-zindex');
//                 }
//             });
      
//             var closestRoot = $($videoWrapper).closest('.article-container')[0];
//             if (closestRoot) {
//                 var closestRootRect = closestRoot.getBoundingClientRect();
//                 var distanceToBottom = window.innerHeight - closestRootRect.bottom;
//             }
              
//             var windowScrollTop = window.scrollY();
//             var videoBottom = videoHeight + $videoBoxWrapper.offsetTop;
//                 // var stopScrollPoint = Math.floor($(closestRoot).height() - $(document).scrollTop() - $(window).height());
      
//             if ( windowScrollTop > videoBottom) {
//                 // $videoBoxWrapper.height(videoHeight);
//                 if (
//                     $videoBoxWrapper.classList.contains('youtube-video-wrapper') &&
//                     $dataEdtn === 'us'
//                 ) {
//                     $videoWrapper.classList.remove('stick');
//                     document.body.classList.remove('custom-zindex');
//                 } else {
//                     $videoWrapper.classList.add('stick');
//                     document.body.classList.add('custom-zindex');
//                 }
//             } else {
//                 // $videoBoxWrapper.height('auto');
//                 $videoWrapper.classList.remove('stick');
//                 document.body.classList.remove('custom-zindex');
//             }
      
//             // stop scroll before some point in the bottom
//             if (distanceToBottom >= 0 && infiniteScrollEdtn.includes($dataEdtn)) {
//                 $videoWrapper.classList.add('stop_stick');
//             } else {
//                 $videoWrapper.classList.remove('stop_stick');
//             }
//         });
//     }

    // if ($videoWrapper != null) {
    //   const $playBtn = document.querySelector('.play-button-svg');
    //   const clearSvg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    //   <title>clear</title>
    //   <path d="M25.312 9.216l-7.424 7.456 7.424 7.424-1.888 1.888-7.424-7.456-7.424 7.456-1.888-1.888 7.424-7.424-7.424-7.456 1.888-1.856 7.424 7.424 7.424-7.424z"></path>
    //   </svg>`;
    //   getLoadMstv().then((api) => {
    //     api.loadMstv( $playBtn, $videoWrapper, clearSvg, $dataEdtn, isMstv);
    //   });
    // }
// }